import { useEffect, useId, useRef, useState } from 'react';
import { Button, Select, Spin, Tag, Typography } from 'antd';
import { searchPushPicks } from '../../api/push_picks';

const statuses = { 0: '新建', 1: '已发布', 2: '已丢弃', 3: '待更新', 4: '待退出', 5: '已退出' };
const optionFor = (pick) => ({
    value: pick.id,
    selectedLabel: `${pick.ticker} · ${pick.id}`,
    label: <div className="push-post-option">
        <div><Tag>{pick.ticker}</Tag>{pick.tickerInfo?.name || ''}</div>
        <Typography.Text type="secondary">ID：{pick.id} · {statuses[pick.status] || '状态未知'}{pick.createdAt ? ` · ${pick.createdAt}` : ''}</Typography.Text>
    </div>,
    pick,
});

export default function PickSelect({ value, ticker, onChange, disabled }) {
    const helpId = useId();
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState('');
    const [matches, setMatches] = useState([]);
    const [status, setStatus] = useState('idle');
    const [selected, setSelected] = useState(null);
    const [retry, setRetry] = useState(0);
    const version = useRef(0);

    useEffect(() => {
        const request = ++version.current;
        if (!open || disabled) { setStatus('idle'); return; }
        setStatus('loading');
        const timer = setTimeout(async () => {
            try {
                const picks = await searchPushPicks(query);
                if (request !== version.current) return;
                setMatches(picks); setStatus(picks.length ? 'ready' : 'empty');
            } catch {
                if (request === version.current) { setMatches([]); setStatus('error'); }
            }
        }, 350);
        return () => { clearTimeout(timer); version.current += 1; };
    }, [open, query, disabled, retry]);

    const choose = (id, option) => {
        version.current += 1;
        setSelected(option?.pick || null);
        setQuery(''); setMatches([]); setOpen(false); setStatus('idle');
        onChange(id || '', option?.pick || null);
    };
    const help = status === 'loading' ? '正在搜索 Pick…'
        : status === 'error' ? 'Pick 搜索失败，请重试；若持续失败，请检查 Pick 查看权限。'
            : status === 'empty' ? '没有匹配的已发布 Pick，请尝试其他 ticker。'
                : '输入完整或部分 ticker 搜索，仅显示已发布 Pick，最多 10 条；选中后使用对应的 Pick ID 打开详情。';
    return <div>
        <Select aria-label="搜索 Pick" aria-describedby={helpId} aria-busy={status === 'loading'}
            showSearch allowClear virtual={false} filterOption={false} disabled={disabled}
            value={value || undefined} searchValue={query} open={open && !disabled} onOpenChange={setOpen}
            onSearch={(text) => { version.current += 1; setQuery(text); setMatches([]); setStatus('loading'); }} onChange={choose}
            labelRender={() => selected?.id === value ? optionFor(selected).selectedLabel : `${ticker ? `${ticker} · ` : 'ID：'}${value}`}
            options={matches.map(optionFor)} optionLabelProp="selectedLabel" style={{ width: '100%' }}
            placeholder="输入 ticker 搜索 Pick，例如 NVDA" loading={status === 'loading'}
            notFoundContent={status === 'loading' ? <Spin size="small" /> : help} />
        <div id={helpId} className="push-secondary" role="status">{help}
            {status === 'error' && <Button type="link" size="small" disabled={disabled} onMouseDown={(event) => event.preventDefault()} onClick={() => { setOpen(true); setRetry((n) => n + 1); }}>重试搜索</Button>}
        </div>
        {value && <div className="push-secondary">已选 Pick ID：{value}</div>}
    </div>;
}
